import { render, staticRenderFns } from "./ColumnChart.vue?vue&type=template&id=60da8cc7&scoped=true&"
import script from "./ColumnChart.vue?vue&type=script&lang=js&"
export * from "./ColumnChart.vue?vue&type=script&lang=js&"
import style0 from "./ColumnChart.vue?vue&type=style&index=0&id=60da8cc7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60da8cc7",
  null
  
)

export default component.exports